import React, { useEffect, useState } from 'react';
import * as TrackingService from 'common/services/tracking.service';
import { SettingValues } from '@linearb/linjs-common';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import {
  LOCAL_STORAGE_KEYS,
  SESSION_STORAGE_KEYS,
  TRACKING,
  SETTING_DEFINITION_LEVELS,
  METRICS
} from 'common/constants/constants';
import PMReport from '../PmReport/PMReport';
import InvestmentProfileCta from '../PmReport/cta/InvestmentProfileCTA';
import TimeDistributionCTA from '../PmReport/cta/TimeDistributionCTA';
import VelocityCTA from '../PmReport/cta/VelocityCTA';
import InvestmentProfileService from '../PmReport/services/investmentProfileService';
import TimeDistributionService from '../PmReport/services/timeDistributionService';
import VelocityService from '../PmReport/services/velocityReportService';
import useSettingsService from 'components/hooks/useSettingsService';
import { isTeamLicenseSelector } from 'state/selectors/license';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import useDoraFeatureFlags from 'views/root/views/home/hooks/useDoraFeatureFlags';
import MetricsAllContributorsIsALimitedViewState from '../CustomReport/EmptyStates/MetricsAllContributorsIsALimitedViewState';

const Jira = ({ currentTeams, filters, onSelectReport }) => {
  const isTeamLicense = useSelector(isTeamLicenseSelector);
  const { isAllControbutorsTeamSelected } = useDoraFeatureFlags();

  const { getSettingOrDefinitionValue } = useSettingsService();
  const location = useLocation();
  const { local: localStorageAccessor, session: sessionStorageAccessor } =
    BrowserStorageAccessor();

  const onAllContributorsCTAClick = route => {
    onSelectReport({ id: route });
  };

  const tabs = [
    {
      name: 'Velocity',
      route: 'issues-velocity',
      service: VelocityService,
      cta: isTeamLicense ? (
        <VelocityCTA />
      ) : (
        <MetricsAllContributorsIsALimitedViewState
          onClick={onAllContributorsCTAClick}
        />
      )
    },
    {
      name: 'Time Distribution',
      route: 'time-distribution',
      service: TimeDistributionService,
      cta: isTeamLicense ? (
        <TimeDistributionCTA />
      ) : (
        <MetricsAllContributorsIsALimitedViewState
          onClick={onAllContributorsCTAClick}
        />
      )
    },
    {
      name: 'Investment Profile',
      route: 'issues-investment',
      service: InvestmentProfileService(
        getSettingOrDefinitionValue(
          {
            name: SettingValues.INVESTMENT_PROFILE_ITERATIONS,
            definitionLevel: SETTING_DEFINITION_LEVELS.organization
          },
          METRICS.TIME_FRAME_FILTER_OPTIONS
        )
      ),
      cta: isTeamLicense ? (
        <InvestmentProfileCta />
      ) : (
        <MetricsAllContributorsIsALimitedViewState
          onClick={onAllContributorsCTAClick}
        />
      )
    }
  ];
  const initialBoardId =
    localStorageAccessor.get(LOCAL_STORAGE_KEYS.SELECTED_BOARD_ID) || null;
  const initialSprintName =
    sessionStorageAccessor.get(SESSION_STORAGE_KEYS.SELECTED_SPRINT_NAME) || '';
  const [selectedBoardId, setSelectedBoardId] = useState(initialBoardId);
  const [selectedSprintName, setSelectedSprintName] =
    useState(initialSprintName);
  const onBoardSelection = boardId => {
    localStorageAccessor.set(LOCAL_STORAGE_KEYS.SELECTED_BOARD_ID, boardId);
    setSelectedBoardId(boardId);
  };
  const selectedTab =
    tabs.find(({ route }) => location.pathname.includes(route)) || tabs[0];
  const onSprintSelection = sprintName => {
    sessionStorageAccessor.set(
      SESSION_STORAGE_KEYS.SELECTED_SPRINT_NAME,
      sprintName
    );
    setSelectedSprintName(sprintName);
  };
  useEffect(() => {
    TrackingService.logEvent(TRACKING.EVENTS.VISIT, {
      page: TRACKING.PAGES.METRICS,
      page_tab: TRACKING.PAGE_TABS.JIRA
    });
  }, []);

  return isAllControbutorsTeamSelected ? (
    <> {selectedTab.cta} </>
  ) : (
    <PMReport
      reportName={selectedTab.name}
      onBoardSelection={onBoardSelection}
      onSprintSelection={onSprintSelection}
      selectedBoardId={selectedBoardId}
      selectedSprintName={selectedSprintName}
      service={selectedTab.service({ selectedBoardId })}
      currentTeams={currentTeams}
      filters={filters}
    />
  );
};

export default Jira;
